export enum BB8ModalTypes {
  Success = 1,
  Warning = 2,
  Error = 3,
  Info = 4
}

export enum BB8ModalSizes {
  Default = "default",
  Medium = "medium",
  Small = "small"
}
